export interface ICartProductImage {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export interface ICartItem {
  product_type: string;
  options: any[]; // Details zu Optionen fehlen im JSON, daher `any[]`
  qty: number;
  item_id: string;
  configure_url: string;
  is_visible_in_site_visibility: boolean;
  product_id: string;
  product_name: string;
  product_sku: string;
  product_url: string;
  product_has_url: boolean;
  product_price: string;
  product_price_value: number;
  product_image: ICartProductImage;
  canApplyMsrp: boolean;
  message: string;
}

export interface ICart {
  summary_count: number;
  subtotalAmount: number;
  subtotal: string;
  possible_onepage_checkout: boolean;
  items: ICartItem[];
  extra_actions: string;
  isGuestCheckoutAllowed: boolean;
  website_id: string;
  storeId: string;
  cartId: string;
  storeViewCode: string;
  cart_empty_message: string;
  subtotal_incl_tax: string;
  subtotal_excl_tax: string;
  data_id: number;
}

export interface ICartCustomerLoggedIn {
  fullname: string;
  firstname: string;
  websiteId: string;
  signin_token: string;
  data_id: number;
}

export interface ICartCustomerLoggedOut {
  data_id: number;
}

export interface ICartData {
  customer?: ICartCustomerLoggedOut | ICartCustomerLoggedIn;
  cart?: ICart;
}

export function isLoggedInCustomer(
  customer?: ICartCustomerLoggedOut | ICartCustomerLoggedIn
): customer is ICartCustomerLoggedIn {
  return !!customer && 'websiteId' in customer && customer.websiteId !== '';
}
